import { render, staticRenderFns } from "./EmployeeDetail.vue?vue&type=template&id=0b483674&scoped=true&"
import script from "./EmployeeDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDetail.vue?vue&type=style&index=0&id=0b483674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b483674",
  null
  
)

export default component.exports